// Module
var code = `<div data-bind="class: \$data.toolbox.classNames">
  <div data-bind="event: { focusout: (_, e)=>\$data.toolbox.focusOut(e)  }" class="svc-toolbox__panel">
    <!-- ko if: \$data.toolbox.showSearch-->
    <div class="svc-toolbox__search-container">
      <!-- ko if: \$data.toolbox.isCompactRendered-->
      <!-- ko component: { name: 'svc-toolbox-tool', params: { item: \$data.toolbox.searchItem, creator: \$data.creator, model: \$data.toolbox, isCompact: \$data.toolbox.isCompactRendered } } -->
      <!-- /ko -->
      <!-- /ko -->
      <!-- ko component: { name: 'svc-search', params: { model: \$data.toolbox.searchManager } } -->
      <!-- /ko -->
      <div class="svc-toolbox__category-separator svc-toolbox__category-separator--search"></div>
    </div>
    <!-- /ko -->
    <!-- ko if: \$data.toolbox.showPlaceholder-->
    <div class="svc-toolbox__placeholder" data-bind="text:\$data.toolbox.toolboxNoResultsFound"></div>
    <!-- /ko -->
    <!-- ko component: { name: 'svc-scroll' } -->
      <!-- ko ifnot: \$data.toolbox.showInSingleCategory -->
      <!-- ko foreach: categories -->
      <div class="svc-toolbox__category" data-bind="css: { 'svc-toolbox__category--collapsed': \$data.collapsed, 'svc-toolbox__category--empty': \$data.empty }">
        <!-- ko if: \$parent.categories().length > 1 -->
        <div class="svc-toolbox__category-header-wrapper">
          <div class="svc-toolbox__category-header" data-bind="click: toggleState, key2click, css: { 'svc-toolbox__category-header--collapsed': \$data.toolbox.canCollapseCategories }">
            <span class="svc-toolbox__category-title" data-bind="text: title"></span>
            <!-- ko if: \$data.toolbox.canCollapseCategories -->
            <div class="svc-toolbox__category-header__controls">
              <sv-svg-icon class="svc-toolbox__category-header__button svc-string-editor__button--expand" data-bind="visible: collapsed" params="iconName: 'icon-arrow-down', size: 'auto'"></sv-svg-icon>
              <sv-svg-icon class="svc-toolbox__category-header__button svc-string-editor__button--collapse" data-bind="visible: !collapsed" params="iconName: 'icon-arrow-up', size: 'auto'"></sv-svg-icon>
            </div>
            <!-- /ko -->
          </div>
        </div>
        <!-- /ko -->
        <!-- ko foreach: items -->
        <!-- ko if: \$data.needSeparator && !\$parent.toolbox.showCategoryTitles-->
        <div class="svc-toolbox__category-separator"></div>
        <!-- /ko -->
        <!-- ko component: { name: 'svc-toolbox-tool', params: { item: \$data, creator: \$parents[1].creator, model: \$parent.toolbox, isCompact: false } } -->
        <!-- /ko -->
        <!-- /ko -->
        </div>
        <!-- /ko -->
        <!-- /ko -->
        <!-- ko if: \$data.toolbox.showInSingleCategory -->
        <div class="svc-toolbox__category">
          <!-- ko foreach: \$data.toolbox.renderedActions -->
          <!-- ko component: { name: 'svc-toolbox-tool', params: { item: \$data, creator: \$parent.creator, model: \$parent.toolbox, isCompact: \$parent.toolbox.isCompactRendered } } -->
          <!-- /ko -->
          <!-- /ko -->
        </div>
        <!-- /ko -->
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;